import React from 'react';
import { useTranslation } from '@pascal/pascal-core';

export function GambleText({ gambleWin, isShowGambleWin, currencySymbolOrCode }) {
  const t = useTranslation();

  return (
    <div className={`tb-gamble-arrow-wrp ${isShowGambleWin ? 'rotate-arrow' : ''}`}>
      <p className='ptb-gamble-txt'>
        {isShowGambleWin
          ? t('SELECT_CARD_TO_WIN')
          : `${t('GAMBLE_OR_CASH_OUT_WIN')} ${gambleWin}${currencySymbolOrCode}`}{' '}
      </p>
      <div className='tb-gamble-arrow-inner'>
        <span className='tb-gamble-arrow-bg' />
        <span className='tb-gamble-arrow-bg' />
      </div>
    </div>
  );
}
